<div class="fcp-breadcrumbs-container">
    <ng-container *ngFor="let item of formattedList; let index = index">
        <a
            class="fcp-breadcrumbs-item"
            [ngClass]="{
                'fcp-breadcrumbs-item-last': isLastItem(index),
                'fcp-breadcrumbs-item-disabled': !item.url
            }"
            [routerLink]="item.url"
            fcp-link
            [size]="size"
            color="info"
        >
            {{ item.label }}
        </a>
        <span *ngIf="!isLastItem(index)" class="fcp-breadcrumbs-chevron"></span>
    </ng-container>
</div>
